import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';
@Component({
    selector: 'app-customer-verification-pending-utf',
    templateUrl: './customer-verification-pending-utf.component.html',
    styleUrls: ['./customer-verification-pending-utf.component.scss'],
    standalone: false
})
export class CustomerVerificationPendingUtfComponent extends CfetBaseComponent implements OnInit {

  openCancelModal = '';
  showCancelModal = false;

  constructor() { super(); }
  @Output() goToDocUpload = new EventEmitter<any>();

  ngOnInit () {
    window.scrollTo(0, 0);
  }

  continueToDocUpload (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.goToDocUpload.emit(true);
    }
  }

  cancelCreation (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

}
